import { render } from "./documentTypeListing.vue?vue&type=template&id=7f2c9b1c&scoped=true"
import script from "./documentTypeListing.js?vue&type=script&lang=js"
export * from "./documentTypeListing.js?vue&type=script&lang=js"

import "./documentTypeListing.vue?vue&type=style&index=0&id=7f2c9b1c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2c9b1c"]])

export default __exports__